/*
 * iv-conversion.js — die beweglichen Teile der sechs Aenderungen vom 19.09.2026.
 *
 * Drei Dinge, und jedes beantwortet eine gemessene Zahl:
 *   1. Kaufleiste auf der Produktseite (mobil)
 *   2. Einleitungstext der Kategorieseite zusammenlegen
 *   3. Zahl der gesetzten Filter am Schalter
 *
 * ------------------------------------------------------------------ Grundsatz
 *
 * Dieses Skript FUEHRT nichts. Es legt keinen Artikel in den Warenkorb, es
 * rechnet keinen Preis, es kennt keine Variante. Der Knopf der Kaufleiste loest
 * den echten Knopf aus, der Preis wird aus der Seite abgelesen. Damit gelten
 * Mindestbestellmenge, Mengenfeld, Variantenlogik und der Kassen-Waechter aus
 * `iv-vat.js` unveraendert weiter — und eine Aenderung dort wirkt hier mit,
 * ohne dass jemand daran denken muss.
 *
 * ------------------------------------------------- Warum kein MutationObserver
 *
 * Dieselbe Regel wie in `iv-vat.js`: Dawn ersetzt bei jedem Variantenwechsel
 * den Inhalt von `#price-<section.id>` durch frisch geholtes Markup. Ein
 * Beobachter darauf loest beim eigenen Schreiben mit aus. Angesetzt wird
 * deshalb an Dawns Meldungen (`dawnVariantChanged`, pubsub `variant-change`)
 * und danach mehrfach nachgezogen, weil Dawns Nachrendern auf ein `fetch`
 * wartet. Die Wartezeiten sind zeichengleich zu `iv-vat.js`: 60/250/600/1200 ms.
 * Und: Preisfelder werden bei JEDEM Lesen frisch gesucht, nie gemerkt.
 */
(function () {
  'use strict';

  var NACHLAUF = [60, 250, 600, 1200];

  function text(el) {
    if (!el) return '';
    var kopie = el.cloneNode(true);
    kopie.querySelectorAll('.visually-hidden').forEach(function (n) {
      n.remove();
    });
    return kopie.textContent.replace(/\s+/g, ' ').trim();
  }

  /*
   * Den sichtbaren Produktpreis lesen.
   *
   * Nicht so einfach, wie es klingt — drei Fallen stecken in diesem Theme,
   * alle am 19.09.2026 in der Vorschau gemessen:
   *
   *   1. Im Preisblock `#price-<section.id>` steht AUCH die Skontozeile
   *      (`div.skonto_price`, „2.153,26 € — 1% Skonto …"). Wer den letzten
   *      Betrag im Block nimmt, zeigt den Skontopreis statt des Preises.
   *   2. Dawn rendert beide Haelften — `.price__regular` UND `.price__sale` —
   *      und blendet die unpassende per CSS aus. Gelesen wird nur die
   *      sichtbare (`offsetParent`).
   *   3. Im Angebotsfall ist `.price-item--regular` der DURCHGESTRICHENE
   *      Vergleichspreis in einem `<s>`. Derselbe Fund wie in `iv-vat.js`
   *      (06.09.2026) — `<s>` wird uebersprungen.
   *
   * Der Preis wird bei JEDEM Aufruf frisch gesucht, nie gemerkt: Dawn ersetzt
   * den ganzen Block beim Variantenwechsel.
   */
  function preisLesen() {
    var behaelter =
      document.querySelector('.product__info-container [id^="price-"]') ||
      document.querySelector('[id^="price-template"]');
    if (!behaelter) return '';

    var kandidaten = behaelter.querySelectorAll('.price-item--sale, .price-item--regular');
    for (var i = 0; i < kandidaten.length; i++) {
      var k = kandidaten[i];
      if (k.tagName === 'S') continue;
      if (k.closest('.skonto_price')) continue;
      if (!k.offsetParent) continue;
      var t = text(k);
      if (/\d/.test(t)) return t;
    }
    return '';
  }

  /* =======================================================================
     1. Kaufleiste
     -----------------------------------------------------------------------
     Gemessen: Die 50-%-Besucherlinie liegt knapp unter „In den Warenkorb
     legen" — rund die Haelfte der mobilen Besucher sieht den Knopf nie.
     ======================================================================= */
  /*
   * Der echte Warenkorbknopf — bei JEDEM Aufruf frisch gesucht.
   *
   * Gemessen am 19.09.2026 in der Vorschau: Dawn ersetzt beim Variantenwechsel
   * nicht nur den Preis, sondern das ganze Kaufformular. Ein einmal gemerkter
   * Verweis (auf das Formular ODER auf den Knopf) zeigt danach auf einen
   * geloesten Knoten — `.click()` darauf tut nichts, still und ohne Fehler.
   * Die Leiste sah funktionsfaehig aus und war es nicht.
   *
   * Es gibt zwei Formulare mit `action="/cart/add"`: das Raten-Formular
   * (`installment`) ohne Knopf und das echte mit `data-type="add-to-cart-form"`.
   * Gesucht wird direkt nach dem Knopf, dann ist die Verwechslung ausgeschlossen.
   */
  function knopfJetzt() {
    return (
      document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"] button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]')
    );
  }

  function kaufleiste() {
    if (!knopfJetzt()) return;

    var leiste = document.createElement('div');
    leiste.className = 'iv-kaufleiste';
    leiste.setAttribute('data-iv-kaufleiste', '');
    leiste.innerHTML =
      '<span class="iv-kaufleiste__text">' +
      '<span class="iv-kaufleiste__preis" data-iv-preis></span>' +
      '<span class="iv-kaufleiste__variante" data-iv-variante></span>' +
      '</span>' +
      '<button type="button" class="button button--primary iv-kaufleiste__knopf" data-iv-knopf></button>';
    document.body.appendChild(leiste);

    var feldPreis = leiste.querySelector('[data-iv-preis]');
    var feldVariante = leiste.querySelector('[data-iv-variante]');
    var knopf = leiste.querySelector('[data-iv-knopf]');

    /*
     * Der Knopf der Leiste ist eine Fernbedienung, keine zweite Kasse. Er
     * klickt den echten Knopf — damit laufen alle Pruefungen, die an ihm
     * haengen (Mindestbestellmenge, Menge, Kassen-Waechter), unveraendert.
     */
    knopf.addEventListener('click', function () {
      var jetzt = knopfJetzt();
      if (!jetzt || jetzt.hasAttribute('disabled')) return;
      jetzt.click();
    });

    function schreiben() {
      feldPreis.textContent = preisLesen();

      var auswahl = document.querySelector('variant-radios input[type="radio"]:checked + label');
      var gewaehlt = auswahl ? auswahl.querySelector('.iv-vw-haupt') || auswahl : null;
      feldVariante.textContent = gewaehlt ? text(gewaehlt) : '';

      var jetzt = knopfJetzt();
      var aus = !jetzt || jetzt.hasAttribute('disabled');
      knopf.textContent = jetzt ? text(jetzt.querySelector('span') || jetzt) : '';
      if (aus) {
        knopf.setAttribute('disabled', 'disabled');
      } else {
        knopf.removeAttribute('disabled');
      }
    }

    var laeufe = [];
    function nachziehen() {
      laeufe.forEach(clearTimeout);
      laeufe = NACHLAUF.map(function (ms) {
        return setTimeout(schreiben, ms);
      });
    }

    document.addEventListener('dawnVariantChanged', function () {
      schreiben();
      nachziehen();
    });
    /* Am Dokument, nicht am Formular: Das Formular selbst wird ausgetauscht,
       ein Hoerer darauf waere nach dem ersten Wechsel taub. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, .product-form__quantity')) {
        schreiben();
        nachziehen();
      }
    });
    if (typeof subscribe === 'function') {
      try {
        subscribe('variant-change', function () {
          schreiben();
          nachziehen();
        });
      } catch (e) {
        /* pubsub gibt es nicht auf jeder Seite — dann reichen die beiden oben. */
      }
    }

    schreiben();

    /*
     * Sichtbar erst, wenn der echte Knopf nach OBEN aus dem Bild ist — nicht,
     * solange er weiter unten noch kommt. Sonst stuende die Leiste schon auf
     * dem ersten Bildschirm und verdeckte den Knopf, zu dem sie fuehrt.
     *
     * KEIN IntersectionObserver, und der Grund ist gemessen (19.09.2026,
     * Vorschau): Dawn ersetzt beim Variantenwechsel den ganzen Kaufblock
     * (`VariantSelects.renderProductInfo`). Der beobachtete Knopf haengt danach
     * los am alten Knoten — der Beobachter meldet nie wieder etwas, und die
     * Leiste bleibt fuer den Rest der Sitzung weg. Genau die Falle, die
     * `iv-vat.js` am 06.09.2026 fuer die Preisfelder beschrieben hat.
     *
     * Also dieselbe Regel: Der Knopf wird bei JEDEM Blick frisch gesucht.
     */
    var laeuftNoch = false;
    function pruefen() {
      laeuftNoch = false;
      var jetzt = document.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (!jetzt) {
        leiste.classList.remove('iv-sichtbar');
        return;
      }
      var kasten = jetzt.getBoundingClientRect();
      leiste.classList.toggle('iv-sichtbar', kasten.bottom < 0);
    }

    function anstossen() {
      if (laeuftNoch) return;
      laeuftNoch = true;
      window.requestAnimationFrame(pruefen);
    }

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
    anstossen();
  }

  /* =======================================================================
     1b. Die gewaehlte Variante in der Ueberschrift — ENTFALLEN am 20.09.2026
     -----------------------------------------------------------------------
     Bis dahin schrieb `variantenLegende()` die Wahl rechts neben den
     Optionsnamen („Speicherkapazitaet .... 5 kWh (LUNA2000-5-S1)").

     Weg damit, auf Ansage MS: Die gewaehlte Kachel ist als einzige
     hervorgehoben, und die Kaufleiste nennt die Wahl ohnehin. Die Zeile sagte
     also ein drittes Mal dasselbe — und weil sie auf eine Zeile gekuerzt wird,
     endete sie auf dem Telefon regelmaessig in „PLENTICORE plus G…".

     Die Beschriftung selbst steht jetzt fest auf „Varianten"
     (`snippets/product-variant-picker.liquid`).
     ======================================================================= */

  /* =======================================================================
     1c. Die Seite bleibt beim Variantenwechsel stehen
     -----------------------------------------------------------------------
     Ansage MS, 20.09.2026: „Wenn man eine Variante auswaehlt, sollte die Seite
     stehen bleiben und nicht an den Seitenanfang scrollen."

     ZWEI URSACHEN, und diese hier ist die zweite. Die erste war ein echter
     Bildlauf (`media-gallery.js` rief `scrollIntoView` auf das Produktbild) —
     der ist an der Quelle abgestellt. Was danach uebrig blieb, ist gar kein
     Bildlauf: Der INHALT UEBER DEN KACHELN aendert seine Hoehe. Die
     Versandzeile traegt das Gewicht der Variante („zzgl. 10,00 EUR Versand
     (19,6 kg)"), die Abholzeile wird je Variante neu geholt, der Preisblock
     wird ersetzt — faellt oder kommt dort eine Zeile dazu, wandert alles
     darunter mit, obwohl die Bildlaufposition unveraendert bleibt.

     Gemessen am 20.09.2026 im Vorschau-Theme: `scrollY` blieb ueber sechs
     Klicks konstant bei 3236, der Kachelblock wanderte dabei von -148 auf
     -185 — also gut 18 px je Klick nach oben. Genau das sieht man als „die
     Seite scrollt leicht nach unten", und es tritt in JEDER Fensterbreite auf.

     ALSO: Nicht das Scrollen unterdruecken (es scrollt ja niemand), sondern
     den Kachelblock an seinem Platz im Bild halten und die Bildlaufposition um
     die Differenz nachfuehren. Verankert wird am Kachelblock und nicht am
     Preis: Wer eine Variante waehlt, sieht auf die Kacheln und den Knopf
     darunter.

     WANN NICHT: Sobald sich jemand ANDERS bewegt — der Mensch mit Rad, Finger
     oder Taste, oder ein Skript mit einem eigenen, gewollten Bildlauf (der
     Berater ruft nach „Diese Groesse waehlen" ein `scrollIntoView`). Erkannt
     wird das daran, dass sich `scrollY` zwischen zwei Nachlaeufen ohne unser
     Zutun geaendert hat. Dann wird abgebrochen, statt dagegenzuhalten.

     Die Nachlaufzeiten sind dieselben wie oben (60/250/600/1200 ms): Dawn holt
     den Preisblock per `fetch`, die Abholzeile ebenso — die Hoehe steht erst
     danach fest.
     ======================================================================= */
  function standHalten() {
    var HOECHSTER_VERSATZ = 600; /* mehr ist kein Nachrutschen, da ist etwas anderes los */

    function block() {
      return document.querySelector('variant-radios');
    }

    document.addEventListener(
      'change',
      function (e) {
        if (!e.target || !e.target.closest || !e.target.closest('variant-radios')) return;
        var anker = block();
        if (!anker) return;

        var soll = anker.getBoundingClientRect().top;
        var abbruch = false;
        var zuletzt = null; /* die Bildlaufposition, die WIR zuletzt hinterlassen haben */

        function fremdBewegt() {
          abbruch = true;
        }
        window.addEventListener('wheel', fremdBewegt, { passive: true, once: true });
        window.addEventListener('touchstart', fremdBewegt, { passive: true, once: true });
        window.addEventListener('keydown', fremdBewegt, { once: true });

        function nachfuehren() {
          if (abbruch) return;
          if (zuletzt !== null && Math.abs(window.scrollY - zuletzt) > 2) {
            abbruch = true; /* jemand anders scrollt — ihm nicht in die Hand fallen */
            return;
          }
          var jetzt = block();
          if (!jetzt) return;
          var versatz = jetzt.getBoundingClientRect().top - soll;
          if (!versatz || Math.abs(versatz) > HOECHSTER_VERSATZ) return;
          window.scrollBy(0, versatz);
          zuletzt = window.scrollY;
        }

        /* Sofort und danach nachgezogen, weil Dawn auf `fetch` wartet. */
        window.requestAnimationFrame(nachfuehren);
        NACHLAUF.forEach(function (ms) {
          setTimeout(nachfuehren, ms);
        });
      },
      true /* Fangphase: messen, BEVOR Dawn den Kaufbereich neu baut */
    );
  }

  /* =======================================================================
     2. Einleitungstext der Kategorieseite
     -----------------------------------------------------------------------
     Gemessen: Die durchschnittliche Faltung liegt am Ende des Textes — kein
     Produkt steht darueber. Der Text bleibt im Quelltext, er wird nur
     zusammengelegt.
     ======================================================================= */
  function einleitung() {
    var text_ = document.querySelector('.collection-hero__description');
    if (!text_) return;

    // Kurze Texte brauchen keinen Schalter.
    if (text_.scrollHeight <= 110) return;

    text_.classList.add('iv-einleitung-kurz');
    text_.id = text_.id || 'iv-einleitung';

    var schalter = document.createElement('button');
    schalter.type = 'button';
    schalter.className = 'iv-einleitung-schalter';
    schalter.setAttribute('aria-expanded', 'false');
    schalter.setAttribute('aria-controls', text_.id);
    schalter.textContent = 'Mehr über diese Kategorie';
    text_.insertAdjacentElement('afterend', schalter);

    schalter.addEventListener('click', function () {
      var offen = text_.classList.toggle('iv-einleitung-kurz') === false;
      schalter.setAttribute('aria-expanded', String(offen));
      schalter.textContent = offen ? 'Weniger anzeigen' : 'Mehr über diese Kategorie';
    });
  }

  /* =======================================================================
     3. Zahl der gesetzten Filter
     -----------------------------------------------------------------------
     Gemessen: 6 von 290 Tippvorgaengen (2 %) gehen auf „Filtern und
     sortieren". Wer filtert, soll wenigstens sehen, dass er es getan hat.
     ======================================================================= */
  function filterzahl() {
    var schalter = document.querySelector('.mobile-facets__open');
    if (!schalter) return;

    var gesetzt = 0;
    var p = new URLSearchParams(window.location.search);
    p.forEach(function (_wert, schluessel) {
      if (schluessel.indexOf('filter.') === 0) gesetzt += 1;
    });
    if (!gesetzt) return;

    var abzeichen = document.createElement('span');
    abzeichen.className = 'iv-filterzahl';
    abzeichen.textContent = String(gesetzt);
    abzeichen.setAttribute('aria-label', gesetzt + ' Filter gesetzt');
    schalter.appendChild(abzeichen);
  }

  function start() {
    try {
      kaufleiste();
    } catch (e) {
      console.warn('iv-conversion: Kaufleiste nicht aufgebaut', e);
    }
    try {
      standHalten();
    } catch (e) {
      console.warn('iv-conversion: Stand nicht gehalten', e);
    }
    try {
      einleitung();
    } catch (e) {
      console.warn('iv-conversion: Einleitung nicht zusammengelegt', e);
    }
    try {
      filterzahl();
    } catch (e) {
      console.warn('iv-conversion: Filterzahl nicht gesetzt', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
